import { render, staticRenderFns } from "./dynamic_issues_print_card.vue?vue&type=template&id=4b81a5ce&lang=pug&"
import script from "./dynamic_issues_print_card.vue?vue&type=script&setup=true&lang=js&"
export * from "./dynamic_issues_print_card.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports